var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("iqos-scroll-with-actions gap-row-" + _vm.paddingSize)},[_c('IQOSHorizontalScroll',{attrs:{"height":_vm.autoHeight ? 'auto' : undefined,"barGap":_vm.barGap,"elementCount":_vm.elementCount,"scrollContainerStyles":_vm.scrollContainerStyles}},[_vm._t("default")],2),_c('div',{class:{
      'iqos-scrollbar-actions': _vm.canShowActions
  }},[_vm._t("actions")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }